import { Component, OnInit } from '@angular/core';
import { JSONRPCError, NetworkError } from '@s8l/client-tree-lib';

import { NodeAuditRecord, StreamsServerService } from 'src/app/services/jsonrpc/streams-server.service';
import { UserAuditRecord, UserServerService } from 'src/app/services/jsonrpc/user-server.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-audit-user-events',
  templateUrl: './audit-user-events.component.html',
  styleUrls: ['./audit-user-events.component.scss']
})
export class AuditUserEventsComponent implements OnInit {
  public readonly dateTimeFormat = environment.dateTimeFormat;

  /**
   * Toggle between USER updates and NODE updates.
   */
  public userUpdates = true;

  /**
   * See User-Server: ActionLogDB#Action
   */
  public userActions: string[] = [null, 'create', 'update', 'delete'];

  /**
   * See CMS-Server: NodeUpdates
   */
  public nodeActions: string[] = [null, 'create', 'update', 'delete', 'resource', 'permission'];

  public batchLimit = 100;

  public loading = false;
  public hasMore = true;
  public records: UserAuditRecord[] | NodeAuditRecord[] = [];
  public error: string = null;

  public includeApi = false;
  public includeUsers = false;
  public filterUsername = '';
  public filterResource = '';
  public filterValue = '';
  public filterAction: string = null;

  private debounceTimeout: any;

  constructor(private users: UserServerService, private streams: StreamsServerService) {}

  async ngOnInit() {
    await this.fetchNext();
  }

  public update(debounceMs = 0) {
    this.loading = true;
    this.hasMore = false;
    this.records = [];
    clearTimeout(this.debounceTimeout);
    this.ensureValidAction();
    this.debounceTimeout = setTimeout(() => this.fetchNext(), debounceMs);
  }

  public async loadMore(event) {
    const mult = event.ctrlKey ? 10 : 1;
    this.fetchNext(this.batchLimit * mult);
  }

  private async fetchNext(limit: number = this.batchLimit) {
    this.loading = true;
    this.error = null;
    const params = {
      username: this.filterUsername,
      resource: this.filterResource,
      action: this.filterAction,
      value: this.filterValue,
      api: this.includeApi,
      unprivileged: this.includeUsers,
      offset: this.records.length,
      limit
    };

    try {
      let logs: UserAuditRecord[] | NodeAuditRecord[];
      if (this.userUpdates) {
        logs = await this.users.auditFetch(params);
      } else {
        logs = await this.streams.auditFetch(params);
      }

      this.hasMore = logs.length >= limit;
      this.records.push(...logs);
    } catch (err) {
      if (err instanceof NetworkError || (err instanceof JSONRPCError && err.code === -32601)) {
        this.error = 'unsupported'; // method not found
      } else if (err instanceof JSONRPCError && err.code === -32001) {
        this.error = 'unauthorized'; // insufficient permission
      } else {
        throw err;
      }
    } finally {
      this.loading = false;
    }
  }

  private ensureValidAction() {
    const actions: string[] = this.userUpdates ? this.userActions : this.nodeActions;
    if (!actions.includes(this.filterAction)) {
      this.filterAction = actions[0];
    }
  }
}
